import React from "react";
import ProjectList from "./projects/ProjectList";
import TeamMembers from "./teams/TeamMembers";

export default function Sidebar() {
  return (
    <>
      <div className="sidebar">
        <ProjectList />

        <TeamMembers />
      </div>
    </>
  );
}
